import { render, staticRenderFns } from "./Contratos2.vue?vue&type=template&id=a9dcc42c"
import script from "./Contratos2.vue?vue&type=script&lang=js"
export * from "./Contratos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports